import React, { useContext } from 'react'
import { Header } from '@pcln/whitelabel-components'
import BootstrapDataContext from '../../../context/BootstrapDataContext'
import { Partner } from '../../../types'

const PartnerHeader = ({ partner }: { partner: Partner }) => {
  const { isMobile } = useContext(BootstrapDataContext)

  return (
    <div id="exp-hdr">
      <div
        className="fixed"
        id={`${partner.partnerCode}-global-header`}
        data-testid={`${partner.partnerCode}-global-header`}
      >
        <Header partner={partner} isMobile={isMobile} />
      </div>
    </div>
  )
}

export default PartnerHeader
